<template>
  <v-container fluid pa-0 ma-0>
    <v-layout row wrap class="ma-0">

      <v-toolbar class="pa-0 ma-0 toolbar-padding" :class="{ 'toolbar-shadow': scrollY === 0 }"
                 color="white" flat dense fixed app>
        <v-btn small flat icon @click="$router.go(-1)">
          <v-icon size="24px">$vuetify.icons.navArrowLeft</v-icon>
        </v-btn>
        <h3 class="display-2" style="margin-bottom: 2px">{{ title }}</h3>
      </v-toolbar>

      <v-flex xs12 class="pa-3">
        <h2>{{ title }}</h2>
      </v-flex>

      <v-flex xs12 class="pa-3 text-xs-left terms-style" v-html="content"></v-flex>

    </v-layout>
  </v-container>
</template>

<script>
  import terms from '@/assets/js/terms';

  export default {
    name: 'Terms',
    computed: {
      title () {
        if (this.$route.name === 'PrivacyPolicy') return terms.privacyPolicy.title;
        else return terms.termsOfService.title;
      },
      content () {
        if (this.$route.name === 'PrivacyPolicy') return terms.privacyPolicy.content;
        else return terms.termsOfService.content;
      },
    },
    data () {
      return {
        scrollY: 0,
      };
    },
    created () {
      window.addEventListener('scroll', this.getScrollY);
    },
    destroyed () {
      window.removeEventListener('scroll', this.getScrollY);
    },
    methods: {
      getScrollY() {
        this.scrollY = window.scrollY;
      },
    }
  }
</script>

<style lang="scss" scoped>
  /deep/.toolbar-shadow .v-toolbar__content {
    box-shadow: 0 2px 3px map-get($colors, background-shadow);
  }

  /deep/.toolbar-padding .v-toolbar__content {
    padding: 0 10px 0 16px;
  }

  /deep/.terms-style {
    line-height: 26px;
    h3 {
      font-size: 16px;
      font-weight: bold;
      letter-spacing: -1px;
      margin-bottom: 24px;
    }
    p {
      font-size: 14px;
      margin-bottom: 24px;
    }
    a {
      text-decoration-line: underline;
      color: map_get($colors, charcoal);
    }
    li {
      font-size: 14px;
    }
    ul, ol {
      list-style-position: outside;
      list-style-type: square;
      padding-left: 30px;
      padding-inline-start: 30px;
      margin-bottom: 24px;
    }
    ol {
      margin-bottom: 16px;
      list-style-type: decimal;
      li {
        margin-bottom: 10px;
      }
    }
  }
</style>
